angular
    .module('MyApp')
    .service('AgendaService', ['$resource', '$q', 'SessionData', 'Configs', function($resource, $q, SessionData, Configs) {

      this.buscarAgendas = function(idCaso){
        let deferr = $q.defer();
         if (idCaso) {
            $resource(Configs.getApiServer() + '/npj/agenda-caso?idCaso=:idCaso',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                  idCaso
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        } else {
            deferr.resolve(false);
        }
        return deferr.promise;
      }

      this.incluirAgenda = function(agendaDTO) {
        let deferr = $q.defer();
        if (agendaDTO) {
          let defer = $q.defer();
          $resource(Configs.getApiServer() + "/npj/insere-agenda-caso", {}, {
                  query: {
                          method: 'POST',
                          cache: false
                      }
              })
              .query(agendaDTO, function(result) {
                  defer.resolve(result);
              }, function(err) {
                  defer.reject(err);
              });

          return defer.promise;
       } else {
           deferr.resolve(false);
       }
       return deferr.promise;
      }
    }]);
